import { render } from "./SideBarConnect.vue?vue&type=template&id=8f093644&scoped=true"
import script from "./SideBarConnect.vue?vue&type=script&lang=js"
export * from "./SideBarConnect.vue?vue&type=script&lang=js"

import "./SideBarConnect.vue?vue&type=style&index=0&id=8f093644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f093644"]])

export default __exports__